import DefaultConfig from './default-config.json';
import SprintRayConfig from './sprintray-config.json';
import VyneDentalConfig from './vyne-config.json';
import AffordableSavingsPlanConfig from './affordablesavingsplan-config.json';

const getConfig = () => {
  const { hostname } = window.location;

  switch (hostname) {
    case 'dev-pace.subscribili.com':
    case 'pace.subscribili.com':
      return SprintRayConfig;
    case 'pace.qa.subscribili.com':
    case 'pace.staging.subscribili.com':
    case 'app.qa.vynedentalplans.com':
    case 'app.staging.vynedentalplans.com':
    case 'app.vynedentalplans.com':
      return VyneDentalConfig;
    case 'app.dev.affordablesavingsplan.com':
    case 'app.qa.affordablesavingsplan.com':
    case 'app.staging.affordablesavingsplan.com':
    case 'app.affordablesavingsplan.com':
      return AffordableSavingsPlanConfig;
    default:
      return DefaultConfig;
  }
};

export default getConfig;
